<template>
    <div class="">
        <!-- Auditable Type Filter -->
        <div    class="my-4 mb-4 flex flex-col border-b w-1/2">
            <label  class="block text-sm font-medium leading-6 text-gray-900"
                    for="email">
                Auditable Type
            </label>
            <div    class="pb-4 mt-1">
                <select2    v-model:value="$data._selectedAuditableType"
                            :options="auditableTypes"
                            :close-on-select="true"
                            class="w-full"
                            placeholder="Select an auditable type"
                            :allow-clear="true"
                ></select2>
            </div>
        </div>

        <!-- Auditable Id Filter -->
        <div    v-if="$data._selectedAuditableType !== null"
                class="my-4 mb-4 flex flex-col border-b w-1/2">
            <label  class="block text-sm font-medium leading-6 text-gray-900"
                    for="email">
                Auditable Id
            </label>
            <div    class="pb-4 mt-1">
                <select2    v-model:value="$data._selectedAuditableId"
                            :allow-clear="true"
                            :close-on-select="true"
                            :options="$data._auditableIdsToSelect"
                            class="w-full"
                            placeholder="Select an auditable type"
                ></select2>
            </div>
        </div>

        <!-- User -->
        <div    class="my-4 flex flex-col w-1/2">
            <label  class="block text-sm font-medium leading-6 text-gray-900"
                    for="email">
                Editing User
            </label>
            <div    class="pb-4 mt-1">
                <select2    v-model:value="$data._userSelected"
                            :options="users"
                            :close-on-select="true"
                            class="w-full"
                            placeholder="Select a User"
                            :allow-clear="true"
                ></select2>
            </div>
        </div>

        <!-- Update Filters -->
        <div    class="flex flex-row justify-between">
            <button-blue-secondary  class="ml-2"
                                    @click="updateFilters">
                Update Filters
            </button-blue-secondary>
        </div>

        <!-- CLear Filters -->
        <div    class="flex flex-row justify-between">
            <button-red-secondary  class="ml-2"
                                    @click="clearFilters">
                Clear Filters
            </button-red-secondary>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import _ from 'lodash'

import {SonicuCoreMixin} from '@/mixins/SonicuCoreMixin'
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import Select2 from "@/components/elements/select2.vue";
import ButtonBlueSecondary from "@/components/elements/buttons/ButtonBlueSecondary.vue";
import ButtonRedSecondary from "@/components/elements/buttons/ButtonRedSecondary.vue";

export default {
    name: "EnhancedAuditIndexFilters",
    emits: ['auditable-type-filter-changed', 'model-instance-id-changed', 'user-filter-changed', 'filters-changed'],
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {ButtonRedSecondary, ButtonBlueSecondary, Select2},
    props: {
        auditableTypes: {
            type: Object,
            required: true,
        },
        auditableTypeFilter: {
            type: [String, null],
            required: true,
        },
        auditableIds: {
            type: Object,
            required: true,
        },
        auditableIdFilter: {
            type: [Number, null],
            required: true,
        },
        users: {
            type: Object,
            required: true,
        },
        userFilter: {
            type: [String, null],
            required: true,
        },
        auditableIdsForModels: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            _selectedAuditableType: this.auditableTypeFilter,
            _selectedAuditableId: this.auditableIdFilter,
            _userSelected: this.userFilter,
            _auditableIdsToSelect: [],
        }
    },
    created() {

    },
    mounted() {
        this.updateAuditableIdsToSelect()
        this.setAuditableId(this.auditableIdFilter)
    },
    methods: {
        updateFilters() {
            this.$emit('auditable-type-filter-changed', this.$data._selectedAuditableType)
            this.$emit('model-instance-id-changed', this.$data._selectedAuditableId)
            this.$emit('user-filter-changed', this.$data._userSelected)
            this.$emit('filters-changed')
        },
        clearFilters() {
            this.$data._selectedAuditableType = null
            this.$data._selectedAuditableId = null
            this.$data._userSelected = null

            this.updateFilters()
        },
        updateAuditableIdsToSelect() {
            // If the auditable type is not selected, we can't select an auditable id.  So, set the selected auditable id to null
            if (_.isNil(this.$data._selectedAuditableType)) {
                this.$data._selectedAuditableId = null
                return
            }

            // Ensure that the auditable type is in the dictionary for auditableIdsForModels
            if (! _.has(this.auditableIdsForModels, this._selectedAuditableType)) {
                this.$data._selectedAuditableId = null
                return
            }

            // Update the auditableIds select box for filter, using the auditableIdsForModels dictionary
            this.$data._auditableIdsToSelect = this.auditableIdsForModels[this.$data._selectedAuditableType]
        },
        setAuditableId(auditableId) {
            if (_.isNil(this.$data._auditableIdsToSelect)) {
                // dictionary for auditable ids isn't created yet, id can't be set
                this.$data._selectedAuditableId = null
                return
            }

            if (! _.has(this.$data._auditableIdsToSelect, auditableId)) {
                // The auditable id is not in the list of valid ids for that type.  We will quit out.
                if (this.$data._selectedAuditableId === auditableId) {
                    // If auditable id is the same as the selected auditable id, reset selected
                    this.$data._selectedAuditableId = null
                }
                return
            }

            // set the selected auditable id, should the candidate prove valid.
            this._selectedAuditableId = auditableId
        }
    },
    computed: {},
    watch: {
        // Props to Data
        auditableTypeFilter(newVal, oldVal) {
            if (newVal === oldVal) {
                return
            }

            this.$data._selectedAuditableType = newVal
        },
        _selectedAuditableType(val, old) {
            if (val === old) {
                return
            }

            this.updateAuditableIdsToSelect()
        },
        userFilter(newVal, oldVal) {
            if (newVal === oldVal) {
                return
            }

            this.$data._selectedAuditableType = newVal
        },
        auditableIdFilter(val, old) {
            if (val === old) {
                return
            }

            try {
                this.$data._selectedAuditableId = parseInt(val)
            }
            catch (e) {
                this.$data._selectedAuditableId = null
                console.error(`Error reading auditable_id: "${val}".  Error: ${e}`)
            }
        },
    },
}
</script>

<style scoped>

</style>